<template>
  <div class="container">
    <div ref="carouselContainer" class="carousel-container">
      <div class="carousel-items">
        <slot></slot>
      </div>
    </div>
    <div class="counter">
      {{ counter }}
    </div>
    <div class="buttons">
      <button
        @click="handlePrev"
        class="prev"
        :class="disablePrev ? 'disabled' : ''"
      >
        <span>Previous</span>
      </button>
      <button
        @click="handleNext"
        class="next"
        :class="disableNext ? 'disabled' : ''"
      >
        <span>Next</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "BoxCarousel",
  data() {
    return {
      isScrolling: false,
      itemCount: 0,
      currentItem: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateScrollState();
    });
    window.addEventListener("resize", this.updateScrollState);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScrollState);
  },
  computed: {
    counter() {
      return `${this.currentItem} de ${this.itemCount}`;
    },
    disablePrev() {
      return this.currentItem === 1;
    },
    disableNext() {
      return this.currentItem === this.itemCount;
    }
  },
  methods: {
    updateScrollState() {
      const container = this.$refs.carouselContainer;
      if (!container) return;

      const items = container.querySelectorAll(".carousel-items > *");

      this.resetScrollPosition();
      this.itemCount = items.length;
      this.currentItem = 1;

      items.forEach(item => {
        item.style.width = `${container.clientWidth}px`;
      });
    },
    resetScrollPosition() {
      this.$refs.carouselContainer.scrollTo({
        left: 0,
        behavior: "smooth"
      });
      this.handleScrolling();
    },
    handlePrev() {
      const container = this.$refs.carouselContainer;
      if (!container) return;

      if (this.isScrolling) return;
      this.isScrolling = true;

      if (this.currentItem > 1) {
        this.currentItem -= 1;
      }

      container.scrollBy({
        left: (container.clientWidth + 20) * -1,
        behavior: "smooth"
      });

      this.handleScrolling();
    },
    handleNext() {
      const container = this.$refs.carouselContainer;
      if (!container) return;

      if (this.isScrolling) return;
      this.isScrolling = true;

      if (this.currentItem < this.itemCount) {
        this.currentItem += 1;
      }

      container.scrollBy({
        left: container.clientWidth + 20,
        behavior: "smooth"
      });

      this.handleScrolling();
    },
    handleScrolling() {
      setTimeout(() => {
        this.isScrolling = false;
      }, 400);
    }
  }
};
</script>
<style scoped>
.container {
  position: relative;
  width: 100%;
}
.carousel-container {
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0 0 40px;
  scrollbar-width: none;
  pointer-events: none;
}
.carousel-container::-webkit-scrollbar {
  display: none;
}
.carousel-items {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin-left: -10px;
  margin-right: -10px;
}
.carousel-items > * {
  flex: 0 0 auto;
  margin: 0 10px;
}
.counter {
  position: absolute;
  bottom: 0;
  left: 0;
  font-style: italic;
  background-color: #fff;
  padding: 3px 8px;
  border-radius: 60px;
}
.buttons {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  gap: 10px;
}
.prev,
.next {
  cursor: pointer;
  font-size: 0;
  width: 30px;
  height: 30px;
  border: none;
  background-color: transparent;
  position: relative;
}
.buttons span {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 14px;
  height: 14px;
  transform: rotate(45deg);
  border: 2px solid #001391;
}
.prev span {
  border-top: none;
  border-right: none;
}
.next span {
  border-left: none;
  border-bottom: none;
}
.buttons .disabled {
  opacity: 0.4;
  pointer-events: none;
}
@media screen and (min-width: 600px) {
  .carousel-container {
    padding-bottom: 0;
  }
  .carousel-items > * {
    max-width: calc(33% - 20px);
    min-width: initial;
  }
  .counter {
    display: none;
  }
  .buttons {
    display: none;
  }
}
</style>
